<script setup>
import { computed, onMounted, ref } from 'vue';
import { fetchData } from '../../fetchData.js';

const isVisible = ref(false);
const isCurrentWeekday = (dayNumber) => new Date().getDay() === dayNumber;
const data = ref([]);
const region = computed(() => window.meta?.region_configuration?.region || 'de');

onMounted(() => {
    if (region.value !== 'de') {
        isVisible.value = false;

        return;
    }

    fetchData('/api/v1/webinar-info')
        .then((response) => {
            data.value = response?.result;
            isVisible.value = isCurrentWeekday(data.value?.weekday);
        })
        .catch((error) => {
            console.error(error);
            isVisible.value = false;
        });
});
</script>

<template>
    <transition
        enter-active-class="transition ease-out duration-300"
        enter-from-class="transform opacity-0 -translate-y-4"
        enter-to-class="transform opacity-100 translate-y-0"
        leave-active-class="transition ease-in duration-200"
        leave-from-class="transform opacity-100 translate-y-0"
        leave-to-class="transform opacity-0 -translate-y-4"
    >
        <div v-if="isVisible" class="relative bg-white border text-black rounded-lg shadow-md mx-4 my-2 p-4 flex items-center gap-4">
            <div class="flex-shrink-0">
                <i class="fi fi-rr-megaphone text-2xl text-blue"></i>
            </div>

            <div class="flex-grow text-sm">
                <p v-html="data?.text" />
            </div>

            <div class="flex-shrink-0">
                <button aria-label="Hinweis schließen" class="p-1 rounded-full hover:bg-blue-200/50 transition-colors" @click="() => (isVisible = false)">
                    <i class="fi fi-rr-cross-small text-lg"></i>
                </button>
            </div>
        </div>
    </transition>
</template>
